export default __webpack_public_path__ + "static/media/melvastype-lemonado-script-textured-italic.5f125d8e.otf";